module.exports = __webpack_public_path__ + "img/Empty state.3cfab156.png";